var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stripe-mobile-redirect"}},[_c('b-button',{on:{"click":_vm.redirect}},[_vm._v("Open the App")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }